import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getApiBase } from '../../config'

class ImageDetail extends Component {
	constructor(props) {
		super(props)
		this.state = {
			imageError: false
		}
	}

	handleImageError = () => {
		this.setState({ imageError: true })
	}

	render() {
		const { image, size = "800x600" } = this.props
		const { imageError } = this.state
		
		if (!image || !image.image_id) {
			return null
		}

		const imageUrl = `${getApiBase()}/images/${image.image_id}/${size}`

		return (
			<div className="image-detail-card">
				<div className="image-detail-image-container">
					{!imageError ? (
						<img
							src={imageUrl}
							alt={image.client_image_id || 'Image'}
							className="image-detail-image"
							onError={this.handleImageError}
						/>
					) : (
						<div className="image-detail-error">
							<span>Image not available</span>
						</div>
					)}
					
					<div className="image-detail-overlay">
						<div className="image-detail-info">
							{image.client_image_id && (
								<div className="image-detail-row">
									<span className="image-detail-label">Client ID:</span>
									<span className="image-detail-value">{image.client_image_id}</span>
								</div>
							)}
							{image.supplier && (
								<div className="image-detail-row">
									<span className="image-detail-label">Supplier:</span>
									<span className="image-detail-value">{image.supplier}</span>
								</div>
							)}
							{image.photographer_name && (
								<div className="image-detail-row">
									<span className="image-detail-label">Photographer:</span>
									<span className="image-detail-value">{image.photographer_name}</span>
								</div>
							)}
							{image.created_at && (
								<div className="image-detail-row">
									<span className="image-detail-label">Created:</span>
									<span className="image-detail-value">
										{new Date(image.created_at).toLocaleDateString()}
									</span>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

ImageDetail.propTypes = {
	image: PropTypes.object.isRequired,
	size: PropTypes.string,
}

export default ImageDetail
